import client from './client';

export async function list(params = {})        { const { data } = await client.get('/api/alerts', { params }); return data; }
export async function acknowledge(id, body = {}) { const { data } = await client.patch(`/api/alerts/${id}`, { acknowledged: true, ...body }); return data; }
export async function updateNotes(id, notes)   { const { data } = await client.patch(`/api/alerts/${id}`, { notes }); return data; }
export async function bulkAcknowledge({ scope, companyId, siteId }) { const { data } = await client.post('/api/alerts/bulk-acknowledge', { scope, companyId, siteId }); return data; }
